import React, { useState, useRef, useEffect } from 'react';
import { IoPersonOutline } from 'react-icons/io5';
import { TbHammer } from 'react-icons/tb';
import './App.css';
import emailjs from '@emailjs/browser';
import toast from 'react-hot-toast';
import CookieConsent from './components/CookieConsent';

// Import images
import logo from './assets/logo.png';
import img1 from './assets/1.jpg';
import img6 from './assets/6.jpg';
import img7 from './assets/7.jpg';
import img9 from './assets/9.jpg';
import img10 from './assets/10.jpg';
import img11 from './assets/11.png';
import img12 from './assets/12.png';
import img13 from './assets/13.png';
import img14 from './assets/14.png';
import bossoviaImg from './images/bossovia.png';
import bajzecerImg from './images/bajzecer.png';
import helmaImg from './images/helma.png';
import kruhImg from './images/kruh.png';
import timImg from './images/tim.png';
import bajzi2Img from './images/bajzi2.png';
import konatelImg from './images/konatel.png';
import timDalsiImg from './images/timdalsi.png';
import heroVideo from './assets/vtitul.mp4';
import heroFallbackImage from './assets/vtitulnahrada.png';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [animatedSections, setAnimatedSections] = useState(new Set());
  const [videoThumbnails, setVideoThumbnails] = useState({});
  const heroVideoRef = useRef(null);
  const [showHeroFallback, setShowHeroFallback] = useState(false);

  


  // Initialize EmailJS
  React.useEffect(() => {
    emailjs.init('XVeZJEBYaYSDzz5FX');
  }, []);

  // Prevent hero video from being paused and hide all controls
  useEffect(() => {
    const video = heroVideoRef.current;
    if (!video) return;

    // Hide all controls programmatically
    const hideControls = () => {
      video.controls = false;
      video.removeAttribute('controls');
      
      // Hide controls using CSS
      const style = document.createElement('style');
      style.textContent = `
        video.hero-video::-webkit-media-controls { display: none !important; }
        video.hero-video::-webkit-media-controls-enclosure { display: none !important; }
        video.hero-video::-webkit-media-controls-panel { display: none !important; }
        video.hero-video::-webkit-media-controls-play-button { display: none !important; }
        video.hero-video::-webkit-media-controls-start-playback-button { display: none !important; }
        video.hero-video::-webkit-media-controls-overlay-play-button { display: none !important; }
        video.hero-video::-webkit-media-controls-overlay-enclosure { display: none !important; }
      `;
      document.head.appendChild(style);
      
      // Try to hide controls via DOM manipulation
      const hideControlsInterval = setInterval(() => {
        const controls = video.querySelectorAll('*');
        controls.forEach(el => {
          if (el.classList && (
            el.classList.contains('controls') ||
            el.classList.contains('play-button') ||
            el.classList.contains('pause-button') ||
            el.getAttribute('data-controls')
          )) {
            el.style.display = 'none';
          }
        });
      }, 100);

      return () => {
        clearInterval(hideControlsInterval);
        document.head.removeChild(style);
      };
    };

    const cleanup = hideControls();

    const forcePlay = () => {
      if (video.paused) {
        video.play().catch(() => {});
      }
    };

    const handlePause = (e) => {
      e.preventDefault();
      e.stopPropagation();
      forcePlay();
    };

    const handleTouchStart = (e) => {
      e.preventDefault();
      e.stopPropagation();
      forcePlay();
    };

    const handleTouchEnd = (e) => {
      e.preventDefault();
      e.stopPropagation();
      forcePlay();
    };

    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      forcePlay();
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    const handlePlay = () => {
      // Ensure video keeps playing
      if (video.paused) {
        video.play().catch(() => {});
      }
    };

    // Add all event listeners
    video.addEventListener('pause', handlePause, { passive: false });
    video.addEventListener('touchstart', handleTouchStart, { passive: false });
    video.addEventListener('touchend', handleTouchEnd, { passive: false });
    video.addEventListener('touchcancel', handleTouchEnd, { passive: false });
    video.addEventListener('click', handleClick, { passive: false });
    video.addEventListener('contextmenu', handleContextMenu, { passive: false });
    video.addEventListener('play', handlePlay);

    // Ensure video is playing - check more frequently
    const playVideo = () => {
      if (video.paused || video.ended) {
        video.currentTime = 0;
        video.play().catch(() => {});
      }
    };

    // Check every 100ms for better responsiveness
    const interval = setInterval(playVideo, 100);

    // Also try to play immediately
    video.play().catch(() => {});

    return () => {
      if (cleanup) cleanup();
      video.removeEventListener('pause', handlePause);
      video.removeEventListener('touchstart', handleTouchStart);
      video.removeEventListener('touchend', handleTouchEnd);
      video.removeEventListener('touchcancel', handleTouchEnd);
      video.removeEventListener('click', handleClick);
      video.removeEventListener('contextmenu', handleContextMenu);
      video.removeEventListener('play', handlePlay);
      clearInterval(interval);
    };
  }, []);

  const galleryItems = [
    { id: 1, src: bajzi2Img, alt: '', type: 'image' },
    { id: 9, src: img9, alt: '', type: 'image' },
    { id: 6, src: konatelImg, alt: '', type: 'image' },
    { id: 7, src: timDalsiImg, alt: '', type: 'image' },
    { id: 11, src: img11, alt: '', type: 'image' },
    { id: 12, src: img12, alt: '', type: 'image' },
    { id: 14, src: img14, alt: '', type: 'image' },
    { id: 'bossovia', src: bossoviaImg, alt: '', type: 'image' },
    { id: 'bajzecer', src: bajzecerImg, alt: '', type: 'image' },
    { id: 'helma', src: helmaImg, alt: '', type: 'image' },
    { id: 'kruh', src: kruhImg, alt: '', type: 'image' },
    { id: 'tim', src: timImg, alt: '', type: 'image' }
  ];

  const serviceItems = [
    {
      title: 'Stagehandi a technika',
      tag: 'Produkcia',
      description:
        'Stavba stageov, rigging a technické prípravy podľa časového plánu.',
    },
    {
      title: 'Helperi',
      tag: 'Tím',
      description:
        'Spoľahliví brigádnici na stavanie, presuny, backstage a podporné úlohy pod dohľadom koordinátora.',
    },
    {
      title: 'Brigádnici',
      tag: 'Ops',
      description:
        'Koordinácia vstupov, bezpečnosť pri práci a súhra s produkciou.',
    },
    {
      title: 'Flexibilita',
      tag: 'Partner',
      description:
        'Prispôsobíme sa zmene rozpisu aj miestu — rýchla komunikácia, férové podmienky.',
    },
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const focusContactMessageField = () => {
    const el = document.getElementById('message');
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => el?.focus(), 350);
  };

  const goToContactMemberSignup = () => {
    scrollToSection('contact');
    window.setTimeout(() => focusContactMessageField(), 550);
  };

  const setImageByIndex = (index) => {
    const totalItems = galleryItems.length;
    if (totalItems === 0) return;
    const normalizedIndex = ((index % totalItems) + totalItems) % totalItems;
    setCurrentImageIndex(normalizedIndex);
    setSelectedImage(galleryItems[normalizedIndex]);
  };

  const openImageModal = (_, index) => {
    setImageByIndex(index);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setCurrentImageIndex(0);
  };

  const goToPreviousImage = () => {
    setCurrentImageIndex((prevIndex) => {
      return prevIndex > 0 ? prevIndex - 1 : galleryItems.length - 1;
    });
  };

  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) => {
      return prevIndex < galleryItems.length - 1 ? prevIndex + 1 : 0;
    });
  };

  const handleKeyDown = (e) => {
    if (selectedImage) {
      if (e.key === 'ArrowLeft') {
        goToPreviousImage();
      } else if (e.key === 'ArrowRight') {
        goToNextImage();
      } else if (e.key === 'Escape') {
        closeImageModal();
      }
    }
  };

  // Get animation class based on section visibility
  const getAnimationClass = (sectionId, animationType = 'slide-in-bottom') => {
    return animatedSections.has(sectionId) ? animationType : '';
  };

  // Add keyboard event listener
  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImage, currentImageIndex]);

  useEffect(() => {
    if (!selectedImage) return;
    setSelectedImage(galleryItems[currentImageIndex]);
    // galleryItems is static for the app lifetime
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentImageIndex]);

  // Generate video thumbnails with localStorage cache
  const generateVideoThumbnail = (videoSrc, videoId) => {
    return new Promise((resolve) => {
      // Check localStorage cache first
      const cacheKey = `video_thumbnail_${videoId}`;
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        resolve(cached);
        return;
      }

      const video = document.createElement('video');
      video.crossOrigin = 'anonymous';
      video.src = videoSrc;
      video.currentTime = 0.1; // Seek to first frame
      video.muted = true;
      video.playsInline = true;
      video.preload = 'metadata';
      
      const handleLoadedData = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = video.videoWidth || 640;
          canvas.height = video.videoHeight || 360;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          const thumbnail = canvas.toDataURL('image/jpeg', 0.8);
          
          // Cache thumbnail in localStorage
          try {
            localStorage.setItem(cacheKey, thumbnail);
          } catch (e) {
            // localStorage might be full, ignore
          }
          
          video.removeEventListener('loadeddata', handleLoadedData);
          video.removeEventListener('error', handleError);
          video.removeEventListener('seeked', handleSeeked);
          resolve(thumbnail);
        } catch (error) {
          resolve(null);
        }
      };

      const handleSeeked = () => {
        handleLoadedData();
      };
      
      const handleError = () => {
        video.removeEventListener('loadeddata', handleLoadedData);
        video.removeEventListener('error', handleError);
        video.removeEventListener('seeked', handleSeeked);
        resolve(null);
      };
      
      video.addEventListener('loadeddata', handleLoadedData);
      video.addEventListener('seeked', handleSeeked);
      video.addEventListener('error', handleError);
      
      video.load();
    });
  };

  // Load thumbnails for all videos (only if static thumbnail is not provided)
  useEffect(() => {
    const loadThumbnails = async () => {
      const videoItems = galleryItems.filter(item => item.type === 'video' && !item.thumbnail);
      const thumbnails = {};
      
      // Load cached thumbnails first
      videoItems.forEach(item => {
        const cacheKey = `video_thumbnail_${item.id}`;
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          thumbnails[item.id] = cached;
        }
      });

      // Set cached thumbnails immediately for fast display
      if (Object.keys(thumbnails).length > 0) {
        setVideoThumbnails(prev => ({ ...prev, ...thumbnails }));
      }
      
      // Generate missing thumbnails in background
      for (const item of videoItems) {
        if (!thumbnails[item.id] && !videoThumbnails[item.id]) {
          const thumbnail = await generateVideoThumbnail(item.src, item.id);
          if (thumbnail) {
            thumbnails[item.id] = thumbnail;
            setVideoThumbnails(prev => ({ ...prev, [item.id]: thumbnail }));
          }
        }
      }
    };
    
    loadThumbnails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Intersection Observer for scroll animations
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sectionId = entry.target.getAttribute('data-section');
            if (sectionId) {
              setAnimatedSections(prev => new Set([...prev, sectionId]));
            }
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    // Observe all sections with data-section attribute
    const sections = document.querySelectorAll('[data-section]');
    sections.forEach(section => observer.observe(section));

    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // EmailJS konfiguraaacia
    const serviceId = 'service_3b9a4id';
    const templateId = 'template_t1o8okd';

    try {
      const result = await emailjs.sendForm(
        serviceId,
        templateId,
        e.target
      );

      console.log('Email sent successfully:', result.text);
      toast.success('Ďakujeme za správu! Čoskoro vás budeme kontaktovať.', {
        duration: 5000,
        position: 'bottom-right',
      });
      e.target.reset(); // Reset formulara
    } catch (error) {
      console.error('Error sending email:', error);
      toast.error('Chyba pri odosielaní správy. Skúste to prosím neskôr.', {
        duration: 5000,
        position: 'bottom-right',
      });
    }
  };

  return (
    <div className="App event-bg-page min-h-screen text-zinc-100 selection:bg-blue-500/30 selection:text-white">
      <nav className="fixed top-0 z-50 w-full border-b border-white/10 bg-zinc-950/75 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 md:h-[4.25rem] items-center justify-between gap-4">
            <button
              type="button"
              onClick={() => scrollToSection('home')}
              className="group flex min-w-0 items-center gap-3 rounded-2xl text-left transition hover:opacity-90"
            >
              <div className="relative shrink-0">
                <img src={logo} alt="" className="h-10 w-auto md:h-11" />
                <span className="pointer-events-none absolute -inset-1 rounded-full bg-gradient-to-tr from-blue-500/40 to-sky-400/30 opacity-0 blur-md transition group-hover:opacity-100" />
              </div>
              <div className="min-w-0">
                <p className="font-display truncate text-sm font-bold tracking-tight text-white md:text-base">ICECREW</p>
                <p className="truncate text-[11px] font-medium uppercase tracking-[0.2em] text-zinc-500">Production</p>
              </div>
            </button>

            <div className="hidden items-center gap-1 lg:flex">
              {[
                ['Domov', 'home'],
                ['Služby', 'services'],
                ['O nás', 'about'],
                ['Galéria', 'gallery'],
              ].map(([label, id]) => (
                <button
                  key={id}
                  type="button"
                  onClick={() => scrollToSection(id)}
                  className="rounded-full px-3 py-2 text-sm font-medium text-zinc-300 transition hover:bg-white/5 hover:text-white"
                >
                  {label}
                </button>
              ))}
              <button
                type="button"
                onClick={() => scrollToSection('contact')}
                className="ml-2 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-blue-600 to-sky-500 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-blue-900/30 transition hover:brightness-110"
              >
                Kontakt
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </div>

            <div className="flex items-center gap-2 lg:hidden">
              <button
                type="button"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-white transition hover:bg-white/10"
                aria-expanded={isMenuOpen}
                aria-label={isMenuOpen ? 'Zavrieť menu' : 'Otvoriť menu'}
              >
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="border-t border-white/10 pb-4 lg:hidden">
              <div className="mt-3 grid gap-1 rounded-2xl border border-white/10 bg-zinc-900/90 p-2 shadow-2xl">
                {[
                  ['Domov', 'home'],
                  ['Služby', 'services'],
                  ['O nás', 'about'],
                  ['Galéria', 'gallery'],
                  ['Kontakt', 'contact'],
                ].map(([label, id]) => (
                  <button
                    key={id}
                    type="button"
                    onClick={() => scrollToSection(id)}
                    className="rounded-xl px-3 py-3 text-left text-sm font-medium text-zinc-200 transition hover:bg-white/5"
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative flex min-h-screen items-center justify-center overflow-x-hidden">
        {showHeroFallback ? (
          <img
            src={heroFallbackImage}
            alt="IceCrew hero"
            className="absolute inset-0 w-full h-full object-cover"
          />
        ) : (
          <video 
            ref={heroVideoRef}
            autoPlay 
            muted 
            loop 
            playsInline
            disablePictureInPicture
            controls={false}
            controlsList="nodownload nofullscreen noremoteplayback"
            className="hero-video absolute inset-0 w-full h-full object-cover"
            style={{ pointerEvents: 'none', userSelect: 'none', WebkitUserSelect: 'none' }}
            onError={() => {
              setShowHeroFallback(true);
            }}
            onContextMenu={(e) => {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }}
            onPause={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (heroVideoRef.current) {
                heroVideoRef.current.play().catch(() => {});
              }
            }}
            onTouchStart={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (heroVideoRef.current) {
                heroVideoRef.current.play().catch(() => {});
              }
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (heroVideoRef.current) {
                heroVideoRef.current.play().catch(() => {});
              }
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (heroVideoRef.current) {
                heroVideoRef.current.play().catch(() => {});
              }
            }}
          >
            <source src={heroVideo} type="video/mp4" />
          </video>
        )}
        <div className="event-hero-vignette pointer-events-none absolute inset-0" />
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(232,121,249,0.15),_transparent_55%)]" />

        <div className="relative z-10 mx-auto flex min-h-screen max-w-7xl flex-col justify-center px-4 pb-12 pt-24 sm:px-6 sm:pb-20 sm:pt-28 lg:px-8 lg:pb-32 lg:pt-36">
          <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-7">
              <div className="fade-in-up mb-6 inline-flex items-center rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-zinc-200 backdrop-blur-md">
                ICECREW PRODUCTION
              </div>
              <h1 className="font-display fade-in-up text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl md:text-6xl xl:text-7xl">
                <span className="event-gradient-text">Eventy bez stresu</span>
                <span className="mt-2 block text-white">— s ľuďmi, ktorí to vedia zabezpečiť.</span>
              </h1>
              <p className="fade-in-up mt-6 max-w-xl text-lg leading-relaxed text-zinc-300 md:text-xl">
                Stage, montáž, brigádnici a technická súhra. Spájame rýchlosť, bezpečnosť a férovú spoluprácu.
              </p>
              <div className="fade-in-up mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
                <button
                  type="button"
                  onClick={() => scrollToSection('gallery')}
                  className="event-shine inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-base font-bold text-zinc-900 shadow-xl transition hover:bg-zinc-100"
                >
                  Naša práca
                  <TbHammer className="h-5 w-5 shrink-0" aria-hidden />
                </button>
                <button
                  type="button"
                  onClick={() => scrollToSection('services')}
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/5 px-8 py-4 text-base font-semibold text-white backdrop-blur transition hover:border-sky-400/50 hover:bg-white/10"
                >
                  Naše služby
                  <IoPersonOutline className="h-5 w-5 shrink-0 text-sky-300" aria-hidden />
                </button>
              </div>
              <dl className="fade-in-up mt-12 grid max-w-lg grid-cols-3 gap-4 border-t border-white/10 pt-8 text-sm text-zinc-400">
                <div>
                  <dt className="text-xs uppercase tracking-wider text-zinc-500">Projekty</dt>
                  <dd className="font-display mt-1 text-lg font-bold text-white">50+</dd>
                </div>
                <div>
                  <dt className="text-xs uppercase tracking-wider text-zinc-500">Ľudí</dt>
                  <dd className="font-display mt-1 text-lg font-bold text-white">40</dd>
                </div>
                <div>
                  <dt className="text-xs uppercase tracking-wider text-zinc-500">Skúsenosti</dt>
                  <dd className="font-display mt-1 text-lg font-bold text-white">3+ roky</dd>
                </div>
              </dl>
            </div>

            <div className="relative lg:col-span-5">
              <div className="rounded-2xl border border-white/15 bg-black/30 p-6 shadow-2xl shadow-black/40 backdrop-blur-xl md:p-8">
                <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-zinc-200">
                  Pre koho
                </div>
                <p className="mt-5 text-base font-medium leading-relaxed text-white md:text-[17px]">
                  Rental firmy, agentúry, promotéri, mestá a produkčné tímy — všade kde treba spoľahlivých ľudí a čistú prácu.
                </p>
                <div className="mt-6 space-y-3 border-l border-[#55C1E7]/45 pl-4">
                  <p className="text-sm leading-relaxed text-zinc-300">
                    Koncerty, festivaly, šport, konferencie, výstavy
                  </p>
                  <p className="text-sm leading-relaxed text-zinc-300">
                    Rýchla nástupnosť a jasná komunikácia na mieste
                  </p>
                  <p className="text-sm leading-relaxed text-zinc-300">
                    Férové podmienky a rešpekt k časovému plánu
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => scrollToSection('contact')}
                  className="mt-8 w-full rounded-full border border-white/25 bg-white/10 py-3.5 text-sm font-semibold text-white backdrop-blur-sm transition hover:border-sky-400/50 hover:bg-white/15"
                >
                  Napíšte nám
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="relative border-t border-white/5 py-20 sm:py-24" data-section="services">
        <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-500/40 to-transparent" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display mb-10 text-center text-4xl font-bold tracking-tight text-[#55C1E7] sm:text-5xl md:text-6xl md:mb-12">
            Služby
          </h2>
          <div className="mx-auto max-w-3xl text-center">
            <h2 className={`font-display text-3xl font-bold text-white sm:text-4xl md:text-5xl ${getAnimationClass('services', 'slide-in-bottom')}`}>
              Váš event pod kontrolou — od A po Z
            </h2>
            <p className={`mt-4 text-lg text-zinc-400 ${getAnimationClass('services', 'slide-in-bottom')}`}>
              Štyri piliere, na ktorých staviame našu spoluprácu so zákazníkmi.
            </p>
          </div>
          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {serviceItems.map((item) => (
              <article
                key={item.title}
                className={`event-glass event-card-hover group relative overflow-hidden rounded-2xl p-6 ${getAnimationClass('services', 'slide-in-bottom')}`}
              >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br from-blue-500/20 to-transparent opacity-0 transition group-hover:opacity-100" />
                <span className="inline-flex rounded-full border border-white/10 bg-white/5 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-sky-300/90">
                  {item.tag}
                </span>
                <h3 className="font-display mt-4 text-lg font-bold text-white">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-400">{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* About */}
      <section id="about" className="relative py-20 sm:py-24" data-section="about">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display mb-10 text-center text-4xl font-bold tracking-tight text-[#55C1E7] sm:text-5xl md:text-6xl md:mb-12">
            O nás
          </h2>
          <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
            <div className={getAnimationClass('about', 'slide-in-left')}>
              <h2 className="font-display text-3xl font-bold text-white sm:text-4xl md:text-5xl">
                Spoľahlivý tím
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-zinc-400">
                Zabezpečujeme spoľahlivých ľudí na prípravu a realizáciu podujatí, výstavbu stageov, montáže a technické práce.{' '}
                <span className="text-zinc-300">
                  Stojíme za skúsenosťami z terénu — vieme, čo znamená stihnúť zmeny plánu a dodržiavať bezpečnosť aj pod tlakom času.
                </span>
              </p>

              <div className="mt-8 rounded-2xl border border-white/10 bg-zinc-950/90 p-6 sm:p-8">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-3xl md:text-[1.75rem]">
                  Naša <span className="text-[#55C1E7]">crew</span> má
                </h3>
                <p className="mt-2 text-xl font-black tracking-[0.25em] text-[#55C1E7] sm:text-2xl" aria-hidden>
                  &gt;&gt;&gt;
                </p>
                <ul className="mt-6 space-y-4 text-left text-sm leading-relaxed text-zinc-200 sm:text-base">
                  <li className="flex gap-3">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-white" aria-hidden />
                    <span>
                      aktuálne školenie <strong className="font-bold text-white">BOZP</strong>
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-white" aria-hidden />
                    <span>
                      vlastné{' '}
                      <span className="font-semibold text-[#55C1E7]">ochranné pracovné pomôcky</span>
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-white" aria-hidden />
                    <span>
                      <strong className="font-bold text-white">crew lídra</strong>, ktorý na mieste koordinuje priebeh prác podľa potreby organizátora
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className={`flex flex-col gap-6 ${getAnimationClass('about', 'slide-in-right')}`}>
              <div className="relative">
                <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-blue-600/35 via-transparent to-sky-500/20 blur-2xl" />
                <div className="relative overflow-hidden rounded-3xl border border-white/10 shadow-2xl">
                  <img src={img12} alt="IceCrew Production tím pri práci" className="h-[22rem] w-full object-cover md:h-[28rem]" />
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/90 via-zinc-950/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                    <p className="font-display text-lg font-bold text-white">Náš tím</p>
                    <p className="mt-2 max-w-md text-sm text-zinc-300">
                      Veľká partia, zladená s produkciou — bezpečne, podľa BOZP a hlavne s chuťou pracovať!
                    </p>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="rounded-2xl border border-blue-500/25 bg-blue-500/10 p-4 sm:p-5">
                  <p className="font-display text-2xl font-bold text-sky-300 sm:text-3xl">100%</p>
                  <p className="mt-1 text-xs font-medium text-zinc-300 sm:text-sm">dôraz na spoľahlivosť</p>
                </div>
                <div className="rounded-2xl border border-sky-400/25 bg-sky-500/10 p-4 sm:p-5">
                  <p className="font-display text-xl font-bold text-white sm:text-2xl">Férovosť</p>
                  <p className="mt-1 text-xs font-medium text-zinc-300 sm:text-sm">pri dohode a na mieste</p>
                </div>
              </div>

              <div className="mt-5 flex w-full justify-center">
                <button
                  type="button"
                  onClick={goToContactMemberSignup}
                  className="w-full max-w-md rounded-2xl bg-white px-6 py-4 text-center text-sm font-semibold text-zinc-900 shadow-md transition hover:bg-zinc-100 sm:text-base"
                >
                  Chcem sa stať členom
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section id="gallery" className="relative border-t border-white/5 bg-zinc-950/40 py-20 sm:py-24" data-section="gallery">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_rgba(34,211,238,0.08),_transparent_60%)]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display mb-8 text-center text-4xl font-bold tracking-tight text-[#55C1E7] sm:text-5xl md:text-6xl md:mb-10">
            Galéria
          </h2>
          <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <h2 className={`font-display text-3xl font-bold text-white sm:text-4xl md:text-5xl ${getAnimationClass('gallery', 'slide-in-bottom')}`}>
                Tu si môžte pozrieť našu prácu.
              </h2>
              <p className={`mt-4 text-lg text-zinc-400 ${getAnimationClass('gallery', 'slide-in-bottom')}`}>
                Fotky aj videá — kliknite na náhľad pre zobrazenie na celú obrazovku.
              </p>
            </div>
            <button
              type="button"
              onClick={() => scrollToSection('contact')}
              className={`inline-flex shrink-0 items-center justify-center rounded-full border border-white/15 bg-white/5 px-5 py-2.5 text-sm font-semibold text-white transition hover:border-sky-400/50 hover:bg-white/10 ${getAnimationClass('gallery', 'slide-in-bottom')}`}
            >
              Mám záujem o spoluprácu
            </button>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {galleryItems.map((item, index) => (
              <div
                key={item.id}
                className={`gallery-item group relative cursor-pointer overflow-hidden rounded-2xl border border-white/10 bg-zinc-900/40 shadow-xl ${getAnimationClass('gallery', 'slide-in-bottom')}`}
                onClick={() => openImageModal(item, index)}
              >
                <span className="absolute left-4 top-4 z-20 inline-flex items-center rounded-full bg-black/50 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white backdrop-blur">
                  {item.type === 'video' ? 'Video' : 'Foto'}
                </span>
                {item.type === 'video' ? (
                  <div className="relative flex h-64 w-full items-center justify-center overflow-hidden bg-zinc-900">
                    {item.thumbnail ? (
                      <img src={item.thumbnail} alt="" className="h-full w-full object-cover transition duration-500 group-hover:scale-105" loading="lazy" />
                    ) : videoThumbnails[item.id] ? (
                      <img src={videoThumbnails[item.id]} alt="" className="h-full w-full object-cover transition duration-500 group-hover:scale-105" loading="lazy" />
                    ) : (
                      <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-zinc-800 to-zinc-950">
                        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/10">
                          <svg className="ml-0.5 h-8 w-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                      </div>
                    )}
                    <video src={item.src} className="hidden" muted loop playsInline preload="none" disablePictureInPicture />
                    <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-90 transition group-hover:opacity-100">
                      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-zinc-900 shadow-lg ring-4 ring-black/20 transition group-hover:scale-105">
                        <svg className="ml-0.5 h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="relative h-64 overflow-hidden">
                    <img src={item.src} alt={item.alt || 'Galéria'} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 transition group-hover:opacity-100" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {selectedImage && (
          <div
            className="modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-md"
            onClick={(e) => {
              if (e.target === e.currentTarget) closeImageModal();
            }}
          >
            <div className="relative w-full max-w-6xl">
              <button
                type="button"
                onClick={closeImageModal}
                className="absolute -top-2 right-0 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-zinc-900/90 text-white shadow-lg transition hover:bg-zinc-800 md:-right-2"
                aria-label="Zavrieť"
              >
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              <button
                type="button"
                onClick={goToPreviousImage}
                className="absolute left-0 top-1/2 z-20 hidden h-12 w-12 -translate-x-4 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-zinc-900/90 text-white shadow-lg transition hover:bg-zinc-800 md:flex"
                aria-label="Predchádzajúce"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <button
                type="button"
                onClick={goToNextImage}
                className="absolute right-0 top-1/2 z-20 hidden h-12 w-12 translate-x-4 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-zinc-900/90 text-white shadow-lg transition hover:bg-zinc-800 md:flex"
                aria-label="Ďalšie"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>

              <div className="overflow-hidden rounded-2xl border border-white/10 bg-zinc-950 shadow-2xl">
                {selectedImage.type === 'video' ? (
                  <video
                    src={selectedImage.src}
                    className="max-h-[80vh] w-full object-contain"
                    controls
                    autoPlay
                    playsInline
                    preload="auto"
                    disablePictureInPicture
                  />
                ) : (
                  <img src={selectedImage.src} alt={selectedImage.alt || ''} className="max-h-[80vh] w-full object-contain" />
                )}
              </div>

              <div className="mt-4 flex items-center justify-center gap-3 md:hidden">
                <button
                  type="button"
                  onClick={goToPreviousImage}
                  className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-zinc-900/90 text-white transition hover:bg-zinc-800"
                  aria-label="Predchádzajúce"
                >
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button
                  type="button"
                  onClick={goToNextImage}
                  className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-zinc-900/90 text-white transition hover:bg-zinc-800"
                  aria-label="Ďalšie"
                >
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>

              <div className="mt-4 flex justify-center">
                <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-zinc-900/80 px-5 py-2 text-sm text-zinc-300 backdrop-blur">
                  <span className="font-mono text-xs text-sky-400">
                    {currentImageIndex + 1} / {galleryItems.length}
                  </span>
                  <span className="h-1 w-1 rounded-full bg-zinc-600" />
                  <span>{selectedImage.type === 'video' ? 'Video' : 'Fotografia'}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      {/* Stats */}
      <section className="relative overflow-hidden border-t border-white/5 py-20 sm:py-24" data-section="achievements">
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-blue-600/12 via-transparent to-sky-500/8" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display mb-10 text-center text-4xl font-bold tracking-tight text-[#55C1E7] sm:text-5xl md:text-6xl md:mb-12">
            Čísla
          </h2>
          <div className="mx-auto max-w-3xl text-center">
            <h2 className={`font-display text-3xl font-bold text-white sm:text-4xl ${getAnimationClass('achievements', 'slide-in-bottom')}`}>
              Čo o nás hovoria naše čísla?
            </h2>
            <p className={`mt-4 text-lg text-zinc-400 ${getAnimationClass('achievements', 'slide-in-bottom')}`}>
              Rýchle nasadenie, stabilný tím a jasná komunikácia.
            </p>
          </div>

          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {[
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                ),
                value: '3+',
                label: 'rokov skúseností',
                accent: 'from-blue-600/20 to-blue-600/0',
              },
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                ),
                value: '50+',
                label: 'úspešných projektov',
                accent: 'from-sky-500/20 to-sky-500/0',
              },
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                ),
                value: '100%',
                label: 'spokojných klientov',
                accent: 'from-blue-500/15 to-sky-400/10',
              },
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                ),
                value: '40',
                label: 'členov tímu',
                accent: 'from-sky-400/15 to-white/5',
              },
            ].map((stat) => (
              <div
                key={stat.label}
                className={`event-glass event-card-hover relative overflow-hidden rounded-2xl p-6 text-center ${getAnimationClass('achievements', 'slide-in-bottom')}`}
              >
                <div className={`pointer-events-none absolute inset-0 bg-gradient-to-br ${stat.accent} opacity-80`} />
                <div className="relative mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-zinc-900/60">
                  <svg className="h-7 w-7 text-sky-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    {stat.icon}
                  </svg>
                </div>
                <p className="font-display relative text-4xl font-extrabold text-white">{stat.value}</p>
                <p className="relative mt-2 text-sm font-medium text-zinc-400">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="relative border-t border-white/5 py-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="event-glass flex flex-col items-start justify-between gap-6 rounded-3xl p-8 md:flex-row md:items-center md:p-10">
            <div>
              <p className="font-display text-xl font-bold text-white md:text-2xl">Máte dátum a miesto?</p>
              <p className="mt-2 max-w-xl text-zinc-400">
                Napíšte nám rozsah — od odhadu ľudí až po časový plán montáže. Radi sa vám ozveme!
              </p>
            </div>
            <button
              type="button"
              onClick={() => scrollToSection('contact')}
              className="inline-flex w-full shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-blue-600 to-sky-500 px-8 py-3.5 text-sm font-bold text-white shadow-lg shadow-blue-900/30 transition hover:brightness-110 md:w-auto"
            >
              Napíšte nám správu
            </button>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="relative border-t border-white/5 pb-24 pt-4 sm:pb-28" data-section="contact">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display mb-10 text-center text-4xl font-bold tracking-tight text-[#55C1E7] sm:text-5xl md:text-6xl md:mb-12">
            Kontakt
          </h2>
          <div className="grid items-start gap-12 lg:grid-cols-12 lg:items-stretch lg:gap-12 xl:gap-14">
            <div className={`lg:col-span-4 ${getAnimationClass('contact', 'slide-in-left')}`}>
              <h2 className="font-display text-3xl font-bold text-white sm:text-4xl md:text-5xl">
                Neváhajte nás kontaktovať!
              </h2>
              <p className="mt-5 text-lg text-zinc-400">
                Pripravíme vám nezabudnuteľný zážitok — s rešpektom k času, rozpočtu a ľuďom na mieste.
              </p>

              <div className="mt-10 space-y-4">
                <div className="event-glass rounded-2xl p-5 transition hover:border-blue-500/35">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#55C1E7]">Konateľ</p>
                  <p className="font-display mt-2 text-2xl font-bold text-white">Daniel Zima</p>
                  <div className="mt-4 space-y-3">
                    <a href="tel:0950754495" className="flex items-center gap-3 text-zinc-200 transition hover:text-white">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                        <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                      </span>
                      <span className="font-medium">0950 754 495</span>
                    </a>
                    <a href="mailto:icecrewproduction@gmail.com" className="flex items-center gap-3 text-sky-200/95 transition hover:text-sky-100">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                        <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </span>
                      <span className="min-w-0 truncate font-medium">icecrewproduction@gmail.com</span>
                    </a>
                  </div>
                </div>

                <div className="event-glass rounded-2xl p-5 transition hover:border-sky-500/35">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#55C1E7]">Koordinátor pre západné Slovensko</p>
                  <p className="font-display mt-2 text-2xl font-bold text-white">Lukáš Šimovec</p>
                  <div className="mt-4 space-y-3">
                    <a href="tel:+421910331676" className="flex items-center gap-3 text-zinc-200 transition hover:text-white">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                        <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                      </span>
                      <span className="font-medium">+421 910 331 676</span>
                    </a>
                    <a href="mailto:lukassimovec074@gmail.com" className="flex items-center gap-3 text-sky-200/95 transition hover:text-sky-100">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                        <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </span>
                      <span className="min-w-0 truncate font-medium">lukassimovec074@gmail.com</span>
                    </a>
                  </div>
                </div>

                <div className="event-glass rounded-2xl p-5 transition hover:border-blue-500/35">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#55C1E7]">Marketing</p>
                  <p className="font-display mt-2 text-2xl font-bold text-white">Nicolas Urban</p>
                  <div className="mt-4 space-y-3">
                    <a href="tel:0949874176" className="flex items-center gap-3 text-zinc-200 transition hover:text-white">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                        <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                      </span>
                      <span className="font-medium">0949 874 176</span>
                    </a>
                    <a href="mailto:nicolas.j.urban@gmail.com" className="flex items-center gap-3 text-sky-200/95 transition hover:text-sky-100">
                      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                        <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </span>
                      <span className="min-w-0 truncate font-medium">nicolas.j.urban@gmail.com</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`flex min-h-0 min-w-0 flex-col lg:col-span-8 lg:h-full ${getAnimationClass('contact', 'slide-in-right')}`}
            >
              <form
                onSubmit={handleSubmit}
                className="event-glass flex min-h-0 w-full flex-1 flex-col gap-5 rounded-3xl p-6 shadow-2xl sm:p-8 lg:h-full lg:min-h-0 lg:p-10"
              >
                <div className="grid shrink-0 gap-5 sm:grid-cols-2">
                  <div>
                    <label htmlFor="name" className="mb-2 block text-xs font-bold uppercase tracking-wider text-zinc-500">
                      Meno
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full rounded-xl border border-white/10 bg-zinc-950/50 px-4 py-3 text-white placeholder-zinc-600 outline-none ring-0 transition focus:border-blue-500/50 focus:ring-2 focus:ring-blue-500/20"
                      placeholder="Vaše meno"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="mb-2 block text-xs font-bold uppercase tracking-wider text-zinc-500">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full rounded-xl border border-white/10 bg-zinc-950/50 px-4 py-3 text-white placeholder-zinc-600 outline-none transition focus:border-sky-500/50 focus:ring-2 focus:ring-sky-500/20"
                      placeholder="vas@email.sk"
                    />
                  </div>
                </div>
                <div className="shrink-0">
                  <label htmlFor="phone" className="mb-2 block text-xs font-bold uppercase tracking-wider text-zinc-500">
                    Telefón
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    pattern="[0-9+\-\s\(\)]+"
                    title="Zadajte len čísla, +, -, medzery a zátvorky"
                    onKeyPress={(e) => {
                      const allowedChars = /[0-9+\-\s\(\)]/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    className="w-full rounded-xl border border-white/10 bg-zinc-950/50 px-4 py-3 text-white placeholder-zinc-600 outline-none transition focus:border-blue-500/50 focus:ring-2 focus:ring-blue-500/20"
                    placeholder="+421 950 000 000"
                  />
                </div>
                <div className="flex min-h-0 flex-1 flex-col gap-2">
                  <label htmlFor="message" className="shrink-0 text-xs font-bold uppercase tracking-wider text-zinc-500">
                    Správa
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={6}
                    required
                    className="min-h-[12rem] w-full flex-1 resize-y rounded-xl border border-white/10 bg-zinc-950/50 px-4 py-3 text-white placeholder-zinc-600 outline-none transition focus:border-blue-400/50 focus:ring-2 focus:ring-sky-500/20"
                    placeholder="Dátum, miesto, rozsah práce…"
                  />
                </div>
                <button
                  type="submit"
                  className={`w-full shrink-0 rounded-2xl bg-gradient-to-r from-blue-600 to-sky-500 py-4 text-sm font-bold uppercase tracking-wide text-white shadow-lg shadow-blue-900/30 transition hover:brightness-110 ${getAnimationClass('contact', 'scale-in')}`}
                >
                  Odoslať správu
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative overflow-hidden border-t border-white/10 bg-zinc-950 text-zinc-300" data-section="footer">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_rgba(59,130,246,0.14),_transparent_55%)]" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12 lg:gap-10">
            <div className={`lg:col-span-5 ${getAnimationClass('footer', 'slide-in-left')}`}>
              <div className="flex items-start gap-4">
                <img src={logo} alt="" className="h-14 w-auto" />
                <div>
                  <p className="font-display text-lg font-bold text-white">ICECREW Production</p>
                  <p className="mt-1 text-sm text-zinc-500">Eventy bez stresu – s nami.</p>
                </div>
              </div>
              <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-400">
                Sme spoľahlivý tím, ktorý vám pomôže s realizáciou vášho podujatia.
              </p>
              <a
                href="https://www.instagram.com/icecrew_production/"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-white transition hover:border-sky-500/45 hover:bg-white/10"
                aria-label="Instagram IceCrew Production"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>

            <div className={`lg:col-span-3 ${getAnimationClass('footer', 'slide-in-bottom')}`}>
              <h4 className="text-lg font-semibold mb-6 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                Rýchle odkazy
              </h4>
              <ul className="space-y-3 text-sm">
                {[
                  ['Domov', 'home'],
                  ['Služby', 'services'],
                  ['O nás', 'about'],
                  ['Galéria', 'gallery'],
                  ['Kontakt', 'contact'],
                ].map(([label, id]) => (
                  <li key={id}>
                    <button
                      type="button"
                      onClick={() => scrollToSection(id)}
                      className="text-left text-zinc-400 transition hover:text-white"
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className={`lg:col-span-4 ${getAnimationClass('footer', 'slide-in-right')}`}>
              <h4 className="text-lg font-semibold mb-6 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                Firma
              </h4>
              <dl className="space-y-3 text-sm">
                <div className="flex flex-wrap gap-x-2 gap-y-1">
                  <dt className="text-zinc-500">Názov</dt>
                  <dd className="text-zinc-200">ICECREW s.r.o.</dd>
                </div>
                <div className="flex flex-wrap gap-x-2 gap-y-1">
                  <dt className="text-zinc-500">IČO</dt>
                  <dd className="text-white">57 409 382</dd>
                </div>
                <div className="flex flex-wrap gap-x-2 gap-y-1">
                  <dt className="text-zinc-500">DIČ</dt>
                  <dd className="text-zinc-200">2122710194</dd>
                </div>
                <div>
                  <dt className="text-zinc-500">Sídlo</dt>
                  <dd className="mt-1 text-white">
                    Okružná 1915/113
                    <br />
                    Stará Ľubovňa 064 01
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <div className={`mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between ${getAnimationClass('footer', 'slide-in-bottom')}`}>
            <p className="text-xs text-zinc-500">&copy; 2026 IceCrew Production. Všetky práva vyhradené.</p>
            <a
              href="https://www.minv.sk/?ochrana-osobnych-udajov-gdpr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-zinc-500 transition hover:text-sky-300"
            >
              Ochrana údajov
            </a>
          </div>
        </div>
      </footer>

      {/* Cookie Consent Banner */}
      <CookieConsent />
    </div>
  );
}

export default App;